/* eslint-disable */
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import { MdArrowBack, MdArrowForward } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import axios from "axios";
import Footer from "../components/Footer";
import { sendUserIntent } from "../api";
import Faqs from "../components/Faqs";
import MASAImpactViewer from "../pages/MASAImpact"
import MemberInsightsSection from "../pages/MemberInsights"

const testimonials = [
  {
    name: "Kanika Gupta",
    text: "I think this a perfect platform for women to come together and grow together. Do something very substantial",
    profileImage: "https://res.cloudinary.com/dnmlijyox/image/upload/testimonial-imgs/kanika.webp"
  },
];



const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentCarouselIndex, setCurrentCarouselIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [direction, setDirection] = useState(0);
  const [testimonialsPerPage, setTestimonialsPerPage] = useState(1);
  const [carouselImages, setCarouselImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imgLoading, setImgLoading] = useState(false);
  const [heroData, setHeroData] = useState({
    // title: "Welcome to MASA Forum",
    // subtitle: "Helping Startups and MSMEs Thrive with Guidance, Tools & Expert Mentorship",
    // buttons: [
    //   { name: "Event Registration", link: "/event-registration" },
    //   { name: "Membership", link: "/membership" },
    //   { name: "Enroll for Acceleration", link: "/register" }
    // ]
  });
  const [dynamicFeatures, setDynamicFeatures] = useState([]);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_SLIDER = `${API_BASE_URL}/UIslider`;
  const API_MEDIA = `${API_BASE_URL}/UImedia`;
  const API_INITIATIVES = `${API_BASE_URL}/UIinitiatives`;
  const API_FEATURES = `${API_BASE_URL}/UIfeatures`;
  const token = localStorage.getItem("token");

  // Fetch active sliders from API
  const fetchSliders = async () => {
    try {
      setLoading(true);
      const res = await axios.get(API_SLIDER, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = res.data.results || res.data;

      
      // console.log("API Response:", data);
      // console.log("First slider URL:", data[0]?.url);

      // Filter only active sliders (active === true) and transform data
      const activeSliders = data.filter(slider => slider.active === true);

      // console.log("Active sliders with URL:", activeSliders.map(s => ({caption: s.caption, url: s.url})));

      // Load images for each slider
      const slidersWithImages = await Promise.all(
        activeSliders.map(async (slider) => {
          let imgUrl = "https://via.placeholder.com/800x400.png?text=No+Image";

          if (slider.src) {
            try {
              const imageRes = await axios.get(`${API_MEDIA}/${slider.src}/download`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: "blob",
              });
              imgUrl = URL.createObjectURL(imageRes.data);
            } catch (error) {
              console.error("Error loading image:", error);
              imgUrl = "https://via.placeholder.com/800x400.png?text=Image+Not+Found";
            }
          }

          return {
            src: imgUrl,
            caption: slider.caption || "MASA Forum",
            id: slider.id,
            url: slider.url || 'https://masaforum.com/' 
          };
        })
      );

      // console.log("Final slider data:", slidersWithImages);
      setCarouselImages(slidersWithImages);

      // If no sliders from API, use fallback images
      if (slidersWithImages.length === 0) {
        setCarouselImages(getFallbackImages());
      }

    } catch (err) {
      console.error("❌ Error fetching sliders:", err);
      // Use fallback images if API fails
      setCarouselImages(getFallbackImages());
    } finally {
      setLoading(false);
    }
  };


  // Fetch hero section data from initiatives API
  const fetchHeroData = async () => {
    try {
      const res = await axios.get(API_INITIATIVES, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = res.data.results || res.data;

      if (data && data.length > 0) {
        // Use the first initiative for hero section
        const firstInitiative = data[0];
        setHeroData({
          title: firstInitiative.title,
          subtitle: firstInitiative.subtitle,
          buttons: firstInitiative.buttons
        });
      }
    } catch (err) {
      console.error("❌ Error fetching initiatives:", err);
      // Keep default data if API fails
    }
  };

  // Fetch dynamic features from API with images
  const fetchDynamicFeatures = async () => {
    try {
      const res = await axios.get(API_FEATURES, {
        headers: { Authorization: `Bearer ${token}` },
      });
      let featuresData = res.data.results || res.data;

      // Filter only active features (isActive === true) and load images
      const featuresWithImages = await Promise.all(
        featuresData
          .filter(feature => feature.isActive === true)
          .map(async (feature) => {
            let imageUrl = null;

            // Load feature image if mediaId exists
            if (feature.mediaId?.id) {
              try {
                const imgRes = await axios.get(`${API_MEDIA}/${feature.mediaId.id}/download`, {
                  headers: { Authorization: `Bearer ${token}` },
                  responseType: "blob",
                });
                imageUrl = URL.createObjectURL(imgRes.data);
              } catch (err) {
                console.error("Error loading image for feature:", feature.title, err);
                imageUrl = "https://via.placeholder.com/400x200.png?text=No+Image";
              }
            } else {
              imageUrl = "https://via.placeholder.com/400x200.png?text=No+Image";
            }

            return {
              id: feature.id,
              title: feature.title,
              desc: feature.description,
              imageUrl: imageUrl,
              isActive: feature.isActive
            };

          })
      );

      // Set features from API
      setDynamicFeatures(featuresWithImages);

    } catch (err) {
      console.error("❌ Error fetching features:", err);
      // If API fails, set empty array
      setDynamicFeatures([]);
    }
  };

  // Responsive testimonial count
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setTestimonialsPerPage(3);
      } else if (window.innerWidth >= 768) {
        setTestimonialsPerPage(2);
      } else {
        setTestimonialsPerPage(1);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch data on component mount
  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([
        fetchSliders(),
        fetchHeroData(),
        fetchDynamicFeatures()
      ]);
    };
    fetchData();
  }, []);

  // Carousel auto-rotation
  useEffect(() => {
    if (carouselImages.length > 0) {
      const interval = setInterval(() => {
        setCurrentCarouselIndex((prev) => (prev + 1) % carouselImages.length);
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [carouselImages.length]);

  const nextSlide = () => {
    setDirection(1);
    setCurrentIndex((prev) =>
      (prev + 1) % (testimonials.length - testimonialsPerPage + 1)
    );
  };

  const prevSlide = () => {
    setDirection(-1);
    setCurrentIndex((prev) =>
      (prev - 1 + testimonials.length) % (testimonials.length - testimonialsPerPage + 1)
    );
  };

  // Popup handling and animations
  useEffect(() => {
    const isFirstVisit = localStorage.getItem("firstVisit");
    if (!isFirstVisit) {
      setShowPopup(true);
      localStorage.setItem("firstVisit", "true");
    }
  }, []);

  const navigate = useNavigate();

  const handlePopupSelection = async (option) => {
    await sendUserIntent(option);
    setShowPopup(false);

    setTimeout(() => {
      switch (option) {
        case "For MASA Awards":
          navigate("/Ourinitiatives");
          break;
        case "For Membership":
          navigate("/membership");
          break;
        case "Startup Incubation":
          navigate("/register");
          break;
        case "know About MASA":
          navigate("/");
          break;
        default:
          break;
      }
    }, 300);
  };

  // Text animation
  const text = heroData.title;
  const [displayedText, setDisplayedText] = useState("");
  const [cursorVisible, setCursorVisible] = useState(true);

  useEffect(() => {
    let index = 0;
    const animateText = () => {
      const interval = setInterval(() => {
        setDisplayedText(text.slice(0, index));
        index++;
        if (index > text.length) {
          clearInterval(interval);
          setTimeout(() => {
            setDisplayedText("");
            index = 0;
            animateText();
          }, 10000);
        }
      }, 150);
    };

    if (text) {
      animateText();
    }

    const cursorInterval = setInterval(() => {
      setCursorVisible((prev) => !prev);
    }, 500);

    return () => {
      clearInterval(cursorInterval);
    };
  }, [heroData.title]);

  const testimonialVariants = {
    enter: (dir) => ({
      x: dir > 0 ? 500 : -500,
      opacity: 0,
      scale: 0.8
    }),
    center: {
      x: 0,
      opacity: 1,
      scale: 1,
      transition: { duration: 0.4 }
    },
    exit: (dir) => ({
      x: dir > 0 ? -500 : 500,
      opacity: 0,
      scale: 0.8,
      transition: { duration: 0.4 }
    })
  };

  const carouselVariants = {
    enter: { opacity: 0 },
    center: { opacity: 1 },
    exit: { opacity: 0 }
  };

  // Loading state for carousel
  if (loading) {
    return (
      <div className="bg-gray-900 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <FaSpinner className="animate-spin text-yellow-500 text-4xl mx-auto mb-4" />
          <p className="text-white text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-900 min-h-screen">

      {/* Carousel Section */}

      <section className="relative h-[40vh] sm:h-screen">
        {carouselImages.length > 0 ? (
          <AnimatePresence mode="wait">
            <motion.div
              key={currentCarouselIndex}
              initial="enter"
              animate="center"
              exit="exit"
              variants={carouselVariants}
              className="absolute inset-0 w-full h-full cursor-pointer" // ✅ यहाँ cursor-pointer add करो
              onClick={(e) => {
                e.stopPropagation();
                const slider = carouselImages[currentCarouselIndex];

                if (slider?.url) {
                  let url = slider.url;

                  if (!url.startsWith('http://') && !url.startsWith('https://')) {
                    url = 'https://' + url;
                  }

                  window.open(url, '_blank', 'noopener,noreferrer');
                }
              }}
            >
              <img
                src={carouselImages[currentCarouselIndex].src}
                alt={carouselImages[currentCarouselIndex].caption}
                className={`w-full h-full object-contain sm:object-cover object-center transition-all duration-500 ${carouselImages[currentCarouselIndex]?.url
                    ? 'cursor-pointer hover:opacity-90 hover:scale-105' // ✅ hover effects add करो
                    : 'cursor-default'
                  }`}
                style={{ cursor: carouselImages[currentCarouselIndex]?.url ? 'pointer' : 'default' }} // ✅ inline style for extra safety
                onLoad={() => setImgLoading(false)}
                onError={(e) => {
                  e.target.src = "https://via.placeholder.com/800x400.png?text=Image+Not+Found";
                }}
              />
              <div className="absolute inset-0 bg-black/50 flex items-center justify-center px-4">
                <motion.h2
                  className="text-2xl sm:text-4xl md:text-5xl font-bold text-white/70 text-center"
                  initial={{ y: 50, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.5 }}
                >
                  {carouselImages[currentCarouselIndex].caption}
                </motion.h2>
              </div>

              {/* URL Indicator - More prominent */}
              {/* {carouselImages[currentCarouselIndex]?.url && (
          <div className="absolute bottom-4 right-4 z-10 bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-bold shadow-lg animate-pulse border-2 border-white">
            🔗 CLICK IMAGE TO OPEN LINK
          </div>
        )} */}
            </motion.div>
          </AnimatePresence>
        ) : (
          <div className="absolute inset-0 bg-gray-800 flex items-center justify-center">
            <p className="text-white text-xl">No sliders available</p>
          </div>
        )}

        {/* Carousel Indicators */}
        {carouselImages.length > 1 && (
          <div className="absolute bottom-8 left-0 right-0 flex justify-center gap-2 z-10">
            {carouselImages.map((_, index) => (
              <button
                key={index}
                onClick={(e) => {
                  e.stopPropagation(); // Stop click from going to parent
                  setCurrentCarouselIndex(index);
                }}
                className={`w-3 h-3 rounded-full transition-all ${currentCarouselIndex === index ? 'bg-yellow-500 w-6' : 'bg-white/50'}`}
              />
            ))}
          </div>
        )}
      </section>

      <MASAImpactViewer />
      {/* Hero Section - Dynamic from Initiatives API */}
      {/* Hero Section - Dynamic from Initiatives API */}
      <motion.section
        className="relative py-9 sm:py-20 px-4 sm:px-6 bg-gray-800 overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        {/* Background Image with Animation */}
        <div className="absolute inset-0">
          <motion.img
            src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
            alt="Background"
            className="w-full h-full object-cover opacity-25"
            initial={{ scale: 1.1, opacity: 0 }}
            animate={{
              scale: 1,
              opacity: 0.25
            }}
            transition={{
              duration: 1.5,
              ease: "easeOut"
            }}
            whileHover={{
              scale: 1.05,
              transition: { duration: 1 }
            }}
            onError={(e) => {
              e.target.src = "https://via.placeholder.com/1920x1080/1f2937/ffffff?text=MASA+Forum";
            }}
          />

          {/* Subtle Moving Gradient Overlay */}
          <motion.div
            className="absolute inset-0"
            style={{
              background: 'linear-gradient(45deg, rgba(31,41,55,0.1) 0%, rgba(31,41,55,0.3) 100%)'
            }}
            animate={{
              backgroundPosition: ['0% 0%', '100% 100%']
            }}
            transition={{
              duration: 10,
              repeat: Infinity,
              repeatType: 'reverse'
            }}
          />
        </div>

        {/* Dark Overlay for better text readability */}
        <div className="absolute inset-0 bg-gray-900/60"></div>

        <div className="relative z-10 max-w-6xl mx-auto">
          <div className="flex flex-col items-center text-center">

            {/* Glowing Badge - Dynamic from API */}
            {heroData.badgeText && (
              <motion.div
                className="relative mb-8"
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.6 }}
              >
                <div className="relative">
                  <div className="absolute -inset-4 bg-gradient-to-r from-yellow-500/30 via-orange-500/30 to-yellow-500/30 rounded-full blur-lg animate-pulse"></div>
                  <div className="relative inline-flex items-center gap-3 bg-gray-900/80 backdrop-blur-sm border border-gray-700/50 rounded-full px-6 py-3">
                    <div className="flex items-center gap-2">
                      <span className="w-2 h-2 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-full animate-ping"></span>
                      <span className="text-yellow-300 font-semibold text-sm tracking-wider">
                        🚀 {heroData.badgeText || "EMPOWERING STARTUPS & MSMEs"}
                      </span>
                    </div>
                  </div>
                </div>
              </motion.div>
            )}

            {/* Main Heading with Gradient Border Effect - Dynamic from API */}
            <motion.div
              className="relative mb-6"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.7 }}
            >
              <div className="absolute -inset-1 bg-gradient-to-r from-yellow-500 via-orange-500 to-yellow-500 rounded-lg blur opacity-30 animate-pulse"></div>
              <h1 className="relative text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold bg-gradient-to-r from-yellow-400 via-orange-300 to-yellow-400 bg-clip-text text-transparent">
                {heroData.title ? (
                  <>
                    {heroData.title}
                    <motion.span
                      animate={{ opacity: cursorVisible ? 1 : 0 }}
                      className="ml-2 text-yellow-400"
                    >
                      |
                    </motion.span>
                  </>
                ) : (
                  "Welcome to MASA Forum"
                )}
              </h1>
            </motion.div>

            {/* Animated Subtitle - Dynamic from API */}
            {heroData.subtitle && (
              <motion.div
                className="relative mb-12 max-w-2xl"
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.3 }}
              >
                <div className="absolute -inset-4 bg-gradient-to-r from-yellow-500/10 to-orange-500/10 rounded-xl blur-xl"></div>
                <p className="relative text-lg sm:text-xl md:text-2xl text-gray-300 leading-relaxed bg-gray-900/50 backdrop-blur-sm p-6 rounded-2xl border border-gray-700/50">
                  {heroData.subtitle}
                </p>
              </motion.div>
            )}

            {/* Animated Button Group - All Buttons with Same Style */}
            {heroData.buttons && heroData.buttons.length > 0 && (
              <motion.div
                className="flex flex-col sm:flex-row gap-4 justify-center"
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.5 }}
              >
                {heroData.buttons.map((button, index) => (
                  <motion.div
                    key={index}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="relative group"
                  >
                    {/* Glow effect for ALL buttons */}
                    <div className="absolute -inset-1 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-lg blur opacity-75 group-hover:opacity-100 transition duration-500 animate-pulse"></div>

                    <Link
                      to={button.link}
                      className="relative px-8 py-4 rounded-lg font-bold transition-all duration-300 transform block bg-gradient-to-r from-yellow-500 to-orange-500 text-gray-900 shadow-2xl hover:shadow-3xl"
                    >
                      <div className="flex items-center justify-center gap-3">
                        <span>{button.name}</span>
                        <motion.svg
                          className="w-5 h-5"
                          animate={{ x: [0, 5, 0] }}
                          transition={{ repeat: Infinity, duration: 1.5 }}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </motion.svg>
                      </div>
                    </Link>
                  </motion.div>
                ))}
              </motion.div>
            )}
          </div>
        </div>
      </motion.section>

      {/* Features Section - Dynamic from Features API */}
      <motion.section
        className="py-12 sm:py-20 px-4 sm:px-6 bg-gray-800"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-100px" }}
      >
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-white mb-8 sm:mb-12">
          Our Key Features
        </h2>

        {dynamicFeatures.length === 0 ? (
          <div className="text-center text-white py-12">
            <p className="text-lg">No features available at the moment.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {dynamicFeatures.map((feature, i) => (
              <motion.div
                key={feature.id}
                className="bg-gray-900 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 group"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                viewport={{ once: true }}
              >
                {/* Feature Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={feature.imageUrl}
                    alt={feature.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    onError={(e) => {
                      e.target.src = "https://via.placeholder.com/400x200.png?text=Feature+Image";
                    }}
                  />
                  <div className="absolute inset-0  group-hover:bg-black/10 transition-all duration-300"></div>
                </div>

                {/* Feature Content */}
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-3 text-white text-center">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400 text-center leading-relaxed">
                    {feature.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </motion.section>

      {/* Testimonials Section - Improved for Mobile
      <motion.section className="py-12 sm:py-16 bg-gray-800 px-4">
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-white mb-8 sm:mb-12">
          Member Insights
        </h2>

        <div className="flex items-center justify-center gap-2 sm:gap-4">
          <button
            onClick={prevSlide}
            className="p-2 bg-gray-800 rounded-full hover:bg-gray-700 transition"
            aria-label="Previous testimonial"
          >
            <MdArrowBack className="text-xl sm:text-2xl text-white" />
          </button>

          <div className="flex overflow-hidden max-w-4xl mx-auto">
            <AnimatePresence initial={false} custom={direction}>
              {testimonials
                .slice(currentIndex, currentIndex + testimonialsPerPage)
                .map((testimonial) => (
                  <motion.div
                    key={testimonial.name}
                    custom={direction}
                    variants={testimonialVariants}
                    initial="enter"
                    animate="center"
                    exit="exit"
                    className="w-full min-w-full sm:min-w-[50%] lg:min-w-[33.333%] p-4 sm:p-6 bg-white rounded-xl mx-1 sm:mx-2"
                  >
                    <div className="flex items-center mb-3 sm:mb-4">
                      <img
                        src={testimonial.profileImage}
                        alt={testimonial.name}
                        className="w-10 h-10 sm:w-12 sm:h-12 rounded-full mr-3 sm:mr-4"
                      />
                      <h3 className="text-gray-900 font-semibold text-sm sm:text-base">{testimonial.name}</h3>
                    </div>
                    <p className="text-gray-600 italic text-sm sm:text-base">"{testimonial.text}"</p>
                  </motion.div>
                ))}
            </AnimatePresence>
          </div>

          <button
            onClick={nextSlide}
            className="p-2 bg-gray-800 rounded-full hover:bg-gray-700 transition"
            aria-label="Next testimonial"
          >
            <MdArrowForward className="text-xl sm:text-2xl text-white" />
          </button>
        </div>
      </motion.section> */}

      <MemberInsightsSection />

      {/* CTA Section - Improved for Mobile */}
      <motion.section
        className="py-12 sm:py-16 bg-gray-800 text-center px-4"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4 sm:mb-6">
            Take your startup or small business to the next level with MASA Forum.
          </h2>
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Link
              to="/membership"
              className="inline-block px-6 py-2 sm:px-8 sm:py-3 bg-yellow-500 text-gray-900 rounded-lg font-semibold text-sm sm:text-base"
            >
              Join Now
            </Link>
          </motion.div>
        </div>
      </motion.section>

      {/* Popup Modal */}
      <AnimatePresence>
        {showPopup && (
          <motion.div
            className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-white p-6 sm:p-8 rounded-xl max-w-md w-full relative mx-4"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
            >
              <h2 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6">Why are you here?</h2>
              <div className="space-y-3 sm:space-y-4">
                {[
                  "For MASA Awards",
                  "For Membership",
                  "Startup Incubation",
                  "know About MASA"
                ].map((option) => (
                  <button
                    key={option}
                    onClick={() => handlePopupSelection(option)}
                    className="w-full py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition text-sm sm:text-base"
                  >
                    {option}
                  </button>
                ))}
              </div>
              <button
                onClick={() => setShowPopup(false)}
                className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
                aria-label="Close popup"
              >
                <IoClose size={24} />
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      <Faqs />
      <Footer />
    </div>
  );
};

export default Home;